import { v4 as uuidv4 } from "uuid";
import bookgridImg from "../images/bookgridImg.png";
import gpt from "../images/gpt.png";
import sonicX from "../images/sonicX.png";
import doggi from "../images/doggi.png";
import saas from "../images/saas.png";

const projects = [
  {
    id: uuidv4(),
    name: "Bookgrid App",
    desc: "An Application for storing and recommending books. Creating slots to input new authors and their recommended books",
    tags: ["Node js", "javascript", "express"],
    img: bookgridImg,
    href: "https://bookgrid-app.herokuapp.com/"
  },
  {
    id: uuidv4(),
    name: "GPT/AI",
    desc: "GPT-3 is trained to generate realistic human text. GPT-3 has been used to create articles, poetry, stories...",
    tags: ["Node js", "javascript", "React"],
    img: gpt,
    href: "https://ajibade3210.github.io/gpt03-webapp/"
  },
  {
    id: uuidv4(),
    name: "SAAS Bootstrap",
    desc: "SAAS bootstrap Application making it easier for Startup to create and own a custom website inn no time",
    tags: ["Node js", "javascript", "React", "material ui"],
    img: saas,
    href: "https://bookgrid-app.herokuapp.com/"
  },
  {
    id: uuidv4(),
    name: "SonicX",
    desc: "Fun Application built using React-js",
    tags: ["Node js", "javascript", "Ejs"],
    img: sonicX,
    href: "https://ajibade3210.github.io/OSonic-FunApp/"
  },
  {
    id: uuidv4(),
    name: "Kernel App",
    desc: "Social blog created using Material UI and React-js...",
    tags: ["Node js", "javascript", "React"],
    img: doggi,
    href: "https://ajibade3210.github.io/Gleblu-Dog-Site/"
  },
];

export default projects;
